import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import CompanyPage from './pages/CompanyPage';
import IndustrialParkPage from './pages/company/IndustrialParkPage';
import EnergyStoragePage from './pages/company/EnergyStoragePage';
import ComplexPage from './pages/company/ComplexPage';
import HospitalPage from './pages/company/HospitalPage';
import PowerDistrictPage from './pages/company/PowerDistrictPage';
import FiveGBasePage from './pages/company/FiveGBasePage';
import DataCenterPage from  './pages/company/DataCenterPage';
import Enersafe  from './pages/company/Enersafe';
import Block from './pages/company/Block';
import HumanResources from  './pages/company/HumanResources';
import EnergyManageSystem from './pages/company/EnergyManageSystem';
import ContactUs from './pages/company/ContactUs';
import News from './pages/company/News';
import Dedails from './pages/company/dedails';
import Dedailp from './pages/company/dedailp';
// /news/dedails
function App() {
  return (
    <Router basename="/">  
      <Routes>
        <Route path="/" element={<CompanyPage />} />  {/* 首页 */}
        <Route path="/company/industrial-park" element={<IndustrialParkPage />} />
        <Route path="/company/energy-storage" element={<EnergyStoragePage />} />
        <Route path="/company/complex" element={<ComplexPage />} />
        <Route path="/company/hospital" element={<HospitalPage />} />
        <Route path="/company/power-district" element={<PowerDistrictPage />} />
        <Route path="/company/5g-base" element={<FiveGBasePage />} />
        <Route path="/company/data-center" element={<DataCenterPage />} />
        <Route path="/company/EnersafeBlock-263-L" element={<Enersafe />} />
        <Route path="/company/Block-100-215-F" element={<Block />} />
         <Route path="/company/HumanResources" element={<HumanResources />} />
        <Route path="/company/EnergyManageSystem" element={<EnergyManageSystem />} />
        <Route path="/company/contact" element={<ContactUs />} />
        <Route path="/company/news" element={<News />} />
        <Route path="/company/news/dedails" element={<Dedails />} />
        <Route path="/company/news/dedailp" element={<Dedailp />} />

      </Routes>
    </Router>
  );
}

export default App;